<template>
  <div class="recommend-items-base">
    <template v-for="(item, index) in itemListMod">
      <article-card
        :key="index"
        :tgt-item="item"
        :tgt-birthday="tgtBirthday"
        @detailBtnClick="onDetailBtnClick(index)"
      ></article-card>
    </template>
  </div>
</template>

<script>
import ArticleCard from "@/utvStore/components/YearLuck/y2020/partials/articleCard";

export default {
  name: "currentSetItems",
  components: { ArticleCard },
  data() {
    return {
      targetIdx: -1,
      targetDetailData: {}
    }
  },
  props: {
    itemList: {
      type: Array,
      default() {
        return []
      }
    },
    tgtBirthday: {
      type: String,
      default() {
        return ''
      }
    }
  },
  computed: {
    itemListMod() {
      return this.itemList
    }
  },
  methods: {
    onDetailBtnClick(idx){
      this.targetIdx = idx
      this.targetDetailData = this.itemList[idx]
      this.$emit('onDetailBtnClick', idx)
    }
  }
}</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/YearLuck/y2020/partials/currentSetItems.vue